import { motion } from "framer-motion";
import { Film } from "lucide-react";

export const AuthCard = ({ subtitle, children }) => (
  <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-4">
    <div className="grain-overlay pointer-events-none absolute inset-0" />
    <div className="pointer-events-none absolute -left-40 -top-40 h-96 w-96 rounded-full bg-primary/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-40 -right-40 h-96 w-96 rounded-full bg-accent/20 blur-3xl" />
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="relative z-10 w-full max-w-md rounded-2xl border border-border bg-card/80 p-8 backdrop-blur-xl shadow-2xl"
    >
      <div className="mb-8 flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground">
          <Film className="h-6 w-6" />
        </div>
        <div>
          <h1 className="font-display text-2xl font-extrabold leading-none tracking-tight">LuminaStream</h1>
          <p className="font-mono-label text-[10px] uppercase tracking-widest text-muted-foreground">{subtitle}</p>
        </div>
      </div>
      {children}
    </motion.div>
  </div>
);
